module.exports = __webpack_public_path__ + "static/media/LOGOPATHBOOKS.10ca32ac.png";